import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { generate } from "random-words";
import Cookies from "js-cookie";
import {checkCompanyReg, validYear} from "../../utilities/company-reg"
import { doc } from "firebase/firestore";
import { CircleLoader } from "react-spinners";

const Register = () => {
    const [firstname, setFirstName] = useState('');
    const [lastname, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [ConfirmPassword, setConfirmPassword] = useState('');

    const [company, setCompany] = useState('');
    const [addCompanyName, setCompanyName] = useState(true)
    const [companyReg, setCompanyReg] = useState('');
    const [companyRegError, setCompanyRegError] = useState('');
    const [validReg, setValidReg] = useState(false)
    const [position, setPosition] = useState('');

    const [phone, setPhone] = useState('');
    const [code, setCode] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const [existingCompanies, setExistingCompanies] = useState([]);

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);


    const navigate = useNavigate();
    const test_company_link = "http://localhost:3000/companies/"
    const production_company_link = "https://apple-tree-server.vercel.app/companies/"


    const test_link = "http://localhost:3000/users/"
    const production_link = "https://apple-tree-server.vercel.app/users/"

    const test_paid_link = "http://localhost:3000/paid/"
    const production_paid_link = "https://apple-tree-server.vercel.app/paid/"


    const checkPaid = async (company_reg) => {
        await axios.post(production_paid_link, {
            company_reg
        })
        .then((res) => Cookies.set('token_status', res.data))
        .catch((err) => console.warn(err))
    }


    const required = async (name, class_id) => {
            if (!name) {
                setError('Please enter all details')
                document.getElementById(class_id).classList.add('border-danger')
            }
    }

    const getCompanies = async () => {
        await axios.get(production_company_link)
        .then(response => {
            setExistingCompanies(response.data);
        })
        .catch(error => console.log(error))
    }

    
    useEffect(() => {
        getCompanies();
    }, []);

    useEffect(() => {
        if (document.getElementById('company-reg') != null) {
            if (!validReg) {
            document.getElementById('company-reg').classList.add('border-danger');
            setCompanyRegError('Enter valid company registration number');
        } else if (validReg) {
            document.getElementById('company-reg').classList.remove('border-danger');
            setCompanyRegError('');
        }
        }
        
    }, [companyReg]);

    const handleSubmit = async () => {
        document.querySelectorAll('.form-control').forEach((input) => {
            input.classList.remove('border-danger')
        })
        setError('')
        const termChecked = document.getElementById('term-check').checked;
        
        if (!termChecked) {
            setError('Accept terms & conditions')
        }
        else if (!firstname || !lastname || !company || !companyReg || !position || !email || !password || !ConfirmPassword) {
            required(firstname, 'first-name');
            required(lastname, 'last-name');
            required(company, 'company');
            required(companyReg, 'company-reg');
            required(position, 'position');
            required(email, 'email');
            required(password, 'password');
            required(ConfirmPassword, 'confirm-password');
            setIsLoading(false);
        } else if (password.length < 5) {
            setPassword('')
            setError('Password must be at least 5 characters')
            setIsLoading(false);
            
        } else if (password !== ConfirmPassword) {
            setPassword('')
            setConfirmPassword('')
            setError("Password don't match")
            setIsLoading(false);

        } else if (!validReg) {
            setError("Enter valid company registration");
            setIsLoading(false);
        } else {

            await axios.post(production_link,
            {
                firstname,
                lastname,
                email,
                company,
                companyReg,
                position,
                phone,
                password,
                code
            }
            )
            .then(async(res) => {
                console.log(res)
                Cookies.set('token_first_name', firstname, { expires: 3 })
                Cookies.set('token_last_name', lastname, { expires: 3 })
                Cookies.set('token_email', email, { expires: 3 })
                Cookies.set('token_company', company, { expires: 3 })
                Cookies.set('token_company_reg', companyReg, { expires: 3 })
                Cookies.set('token_position', position, { expires: 3 })
                Cookies.set('token_phone', phone, { expires: 3 })
                Cookies.set('token_id', res.data[0].id, { expires: 3 })
                Cookies.set('token_admin', res.data[0].admin, { expires: 3 })
                
                await checkPaid(res.data[0].company_reg)
                .then((res) => console.log('Payment checked successfully: ' + res))
                .catch((err) => console.warn("Payment couldnt be checked: " + err))
                navigate('/')
                setIsLoading(false)
                window.location.reload(false)
            })
            .catch(err => {
                console.log(err.response.data);
                setError(err.response.data)
            })
            setIsLoading(false);      

        }
        setIsLoading(false);      

    }

    if (existingCompanies.length == 0 || existingCompanies == null) {
        return (
           <div>


              <h4 className="text-center display-5 fst-italic text-muted">Blacklist</h4>
                   
                  <div style={{height:"50vh"}} className="d-flex justify-content-center align-items-center ">
                  
                              <CircleLoader size={200} color="#cdc59a"/>
              </div>
              </div> 
        )
        
    }

    return (
        <div className="reg-form d-flex justify-content-center align-items-center " onSubmit={handleSubmit}>
            <div className="w-75">
                <form className=" border p-4 rounded">
                    <h2 className="display-5 text-center text-muted">Register Client</h2>

                    <label for="firstname" className="form-label">First name: <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" id="first-name" onChange={(e) => {
                        setFirstName(e.target.value)
                    }} value={firstname}/>

                    <label for="lastname" className="form-label">Last name: <span className="text-danger">*</span></label>
                    <input type="text" className="form-control" id="last-name" onChange={(e) => {
                        setLastName(e.target.value)
                    }} value={lastname}/>

                    <label for='email' className="form-label" >Email Address: <span className="text-danger">*</span></label>
                    <input id="email" type="email" name="email" className="form-control" onChange={(e) => {
                        setEmail(e.target.value)
                    }} value={email}/>

                    <label for='company' className="form-label">Company name: <span className="text-danger">*</span></label>
                    <select id="companyselect" className="form-select w-50 mb-2" onChange={(e) => {
                        if (e.target.value !== "Other") {
                            setCompanyReg(e.target.value.split('|')[1]);
                            setCompany(e.target.value.split('|')[0]);
                            setValidReg(checkCompanyReg(e.target.value.split('|')[1]));
                            setCompanyName(false)
                        } else {
                            setCompany('')
                            setCompanyReg('')
                            setCompanyName(true)
                        }
                    }}>
                        <option selected value="Other">Other</option>

                        {existingCompanies.map((existingCompany) => {
                            return (
                                <option value={`${existingCompany.name}|${existingCompany.registration_number}`} 
                                >{existingCompany.name}</option>
                            )
                        })}

                    </select>
                    {
                       addCompanyName &&
                       
                       <input placeholder="*If other" id="company" name="company" className="form-control" onChange={(e) => {
                    setCompany(e.target.value)
                    }} value={company}/>
                    
                    
                    }

                    {
                        !addCompanyName &&
                        <input placeholder="Code *" id="code" name="code" className="form-control" onChange={(e) => {
                            setCode(e.target.value)
                            }} value={code}/>
                    }
                    
                    
                    {
                        addCompanyName &&
                        <>
                        <label for='company-reg' className="form-label">Company registration number: <span className="text-danger">*</span></label>
                    <input id="company-reg" name="company-reg" className="form-control" onChange={(e) => {
                        setCompanyReg(e.target.value);
                        setValidReg(checkCompanyReg(e.target.value));
                    }} value={companyReg}/>
                    <p className="text-danger text-center">{companyRegError}</p>

                        </>

                    }
                 
                        <label hidden for='company-reg' className="form-label">Company registration number: <span className="text-danger">*</span></label>
                    <input hidden id="company-reg" name="company-reg" className="form-control" onChange={(e) => {
                        setCompanyReg(e.target.value);
                        setValidReg(checkCompanyReg(e.target.value));
                    }} value={companyReg}/>
                    

                    
                    


                    <label for='position' className="form-label">Position: <span className="text-danger">*</span></label>
                    <input id="position" name="position" className="form-control" onChange={(e) => {
                        setPosition(e.target.value)
                    }} value={position}/>

                    <label for="phone" className="form-label">Phone number:</label>
                    <input id="phone" type="tel" className="form-control" onChange={(e) => {
                        setPhone(e.target.value)
                    }} value={phone}/>  

                    <label for='password' className="form-label">Password: <span className="text-danger">*</span></label>
                    
                    
                    <div className="form-control d-flex justify-content-between" id='password-border'>
                        <input className="w-100 form-control border-0 shadow-none" type="password" id="password" name="password" style={{border: "none"}} onChange={(e) => {
                        setPassword(e.target.value)
                        }} value={password}/>
                    
                        {!showPassword && 
                            <button className="btn h-75" onClick={(e) => {
                                e.preventDefault();
                                setShowPassword(true);
                                document.getElementById('password').type = 'text';
                            }}>
                                <i class="bi bi-eye-slash" id="togglePassword"></i>
                            </button>     
                        }
                        {showPassword && 
                            <button className="btn h-75" onClick={(e) => {
                                e.preventDefault();
                                setShowPassword(false);
                                document.getElementById('password').type = 'password';
                            }}>
                                <i class="bi bi-eye"></i>
                            </button>     
                        }

                    </div>

                    <label for='password' className="form-label">Confirm password: <span className="text-danger">*</span></label>

                    <div className="form-control d-flex justify-content-between" id='confirm-password-border'>
                    <input type="password" id="confirm-password" name="password" className="form-control border-0 shadow-none" onChange={(e) => {
                        setConfirmPassword(e.target.value);
                        if (error === "Password don't match") {
                            setError('')
                        }
                        if (password !== e.target.value) {
                            document.getElementById('confirm-password-border').classList.add('border-danger');
                        } else {
                            document.getElementById('confirm-password-border').classList.remove('border-danger');
                        } 
                    }} value={ConfirmPassword}/>
                    
                        {!showConfirmPassword && 
                            <button className="btn h-75" onClick={(e) => {
                                e.preventDefault();
                                setShowConfirmPassword(true);
                                document.getElementById('confirm-password').type = 'text';
                            }}>
                                <i class="bi bi-eye-slash" id="togglePassword"></i>
                            </button>     
                        }
                        {showConfirmPassword && 
                            <button className="btn h-75" onClick={(e) => {
                                e.preventDefault();
                                setShowConfirmPassword(false);
                                document.getElementById('confirm-password').type = 'password';
                            }}>
                                <i class="bi bi-eye"></i>
                            </button>     
                        }

                    </div>
                    <div class="form-check d-flex justify-content-center my-3">
                        <input class="form-check-input me-3" type="checkbox" value="" id="term-check"/>
                        <label class="form-check-label" for="flexCheckDefault">
                            I have read and accepted the <a target="_blank" href="/terms">Terms & conditions</a>
                        </label>
                    </div>
                    

                    <p className="text-danger text-center">{error}</p>
                    <div className="mt-3 d-flex justify-content-center">
                    {!isLoading &&  <button class='btn btn-primary' onClick={(e) => {
                        e.preventDefault();
                        setIsLoading(true);
                        handleSubmit();
                    }}>Submit</button>}
                        {isLoading && 
                        <button class="btn btn-secondary" type="button" disabled>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        Loading...
                        </button>
                        }                 
                    </div>
                </form>
            </div>
        </div> 
        
     );
}
 
export default Register;